const REGION_SEPARATOR = '-';

const getBaseLanguage = (code: string): string => {
  const [base = code] = code.split(REGION_SEPARATOR);

  return base;
};

/**
 * Maps a browser language onto the offered languages: exact match, then the base language (de-AT → de),
 * then a regional variant of the same base language (en, en-US → en-GB), the preferred one first.
 * Null when nothing matches, so the caller moves on to the next candidate.
 */
export const matchLanguage = (candidate: unknown, languages: readonly string[], preferred: string): string | null => {
  if (typeof candidate !== 'string' || !candidate) {
    return null;
  }

  if (languages.includes(candidate)) {
    return candidate;
  }

  const base = getBaseLanguage(candidate);

  if (languages.includes(base)) {
    return base;
  }

  const variants = languages.filter((language) => getBaseLanguage(language) === base);

  return variants.includes(preferred) ? preferred : (variants[0] ?? null);
};
